import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { menuMobx, cartMobx } from 'restaurant'
import { advertMobx, buyTogetherMobx, decorationMobx, storeMobx } from '@mobxStore'
import { ddayjs } from '@dt/fe-utils'
import { find, forEach, sortBy } from '@dt/fe-utils/dist/lodash'
import { ProductAPI } from '@api/index'
import ProductItem from './ProductItem'
import './index.scss'

// interface
interface IProps {
  /** 用于点单新模板 旧版区分 */
  useType?: 'waterfall' | 'default';
}

/**
 * 餐品橱窗广告
 */
const ShowWindow: FC<IProps> = ({ useType = 'default' }) => {
  const [recoramdProducts, setRecoramdProducts] = useState([])
  const isBuyTogether = !!Config.buyTogetherId
  const type = 'shopwindow'
  const { advertInfo, availableAdsMap, shopWindowRecommendInfo } = advertMobx
  const advert = advertInfo[type] || null
  const advertAdList = availableAdsMap[type] || []

  const getProductToShow = (list: { productNo: string; ad: TAdvert }[]) => {
    let hasProds = []
    forEach(list, (item) => {
      if (item.productNo) {
        const hasProd = find(menuMobx.products, (prod) => item.productNo === prod.no)
        if (hasProd) {
          hasProds.push({ ...hasProd, ad: item.ad })
        }
      }
    })
    // 售罄排在最后
    hasProds = sortBy(hasProds, (prod) => prod.saleCnt === 0 ? 99 : 1)
    setRecoramdProducts(hasProds)
  }

  // 自动类型 橱窗餐品数据，通过大棚接口获取
  const getRecommendProducts = async () => {
    const { queueType = 'auto' } = advert.extInfo
    if (queueType === 'auto') {
      getProductToShow(shopWindowRecommendInfo.list)
    } else {
      const list = advertAdList.map((item) => ({ productNo: (item.products[0]?.productNo) || '', ad: item }))
      getProductToShow(list)
    }
  }

  useEffect(() => {
    if (menuMobx.products.length && availableAdsMap[type].length) {
      getRecommendProducts()
    } else {
      setRecoramdProducts([])
    }
  }, [menuMobx.products, availableAdsMap[type], shopWindowRecommendInfo, cartMobx.info.eatType, storeMobx.info.storeId])

  return recoramdProducts.length ? (
    <div className={`shopwindow-container ${useType}`}>
      <div className='shopwindow-scroll-wrapper'>
        <div className='product-list-wrap'>
          {
            recoramdProducts.map((product, index) => {
              const count = isBuyTogether ? buyTogetherMobx.productNoToCntMapForMenu?.[product.no] || 0 : cartMobx.cartResult?.productNoToCntMap?.[product.no] || 0
              return <ProductItem index={index} ad={product.ad} key={`${product.no}_${index}`} decorate={decorationMobx.mealDecorates} count={count} product={product} />
            })
          }
        </div>
      </div>
    </div>
  ) : null
}

export default observer(ShowWindow)
